import { useMemo } from "react";

import { useRentDetails } from "../../CustomHooks/Queries";

import { formatCurrency } from "../../Utils/helpers";

import { RentDetails as RentDetailsIllustration } from "../../Assets/Images";

export default function RentDetails() {
  const { data: rentDetails } = useRentDetails();

  const address = useMemo(() => {
    const user = rentDetails?.data?.data?.my_home_rent;
    if (!user || !user?.address1) return "";

    if (!!user?.address2) {
      return `${user.address1} ${user.address2}`;
    } else {
      return user.address1;
    }
  }, [rentDetails?.data?.data?.my_home_rent]);

  const { rentAmount } = useMemo(() => {
    const myHomeRent = rentDetails?.data?.data?.my_home_rent || {};
    const rentAmount = myHomeRent?.rent_amount || 0;

    return { rentAmount };
  }, [rentDetails]);

  return (
    <div className="rent-details">
      <div className="content">
        <div className="detail">
          <span className="detail-name">My Home</span>
          <span className="detail-value">{address}</span>
        </div>
        <div className="detail">
          <span className="detail-name">Rent price</span>
          <span className="detail-value">{formatCurrency(rentAmount)}</span>
        </div>
      </div>
      <img className="illustration" src={RentDetailsIllustration} alt="" />
    </div>
  );
}
